import { render, staticRenderFns } from "./Vrequirement.vue?vue&type=template&id=9aa7cbfe"
import script from "./Vrequirement.vue?vue&type=script&lang=js"
export * from "./Vrequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports